import { supabase } from '@/lib/supabase';

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL as string;

export type NotificationEvent =
  | { type: 'exercise_assigned'; student_id: string; exercise_id: string }
  | { type: 'exercise_completed'; exercise_id: string }
  | { type: 'class_joined'; class_id: string }
  | { type: 'tutor_invite_sent'; student_id: string }
  | { type: 'tutor_invite_accepted'; link_id: string }
  | { type: 'exercise_photo_submitted'; submission_id: string }
  | { type: 'rendezvous_scheduled'; student_id: string; reservation_id: string }
  | { type: 'discussion_message_sent'; discussion_id: string };

/** Best-effort : ne bloque jamais le flow principal. */
export async function sendNotification(event: NotificationEvent): Promise<void> {
  try {
    const {
      data: { session },
    } = await supabase.auth.getSession();
    if (!session) return;
    await fetch(`${SUPABASE_URL}/functions/v1/send-notification`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${session.access_token}`,
      },
      body: JSON.stringify(event),
    });
  } catch {
    // intentionally swallowed — push is best-effort
  }
}
